/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.WvAttributes";
        class ComponentWvAttributes extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, callbacks = {}) {
                super(core, container, parent);
                this._isReady = null;
                this._isWaitingDisplayData = null;
                this._form = null;
                this._formList = null;
                this._currentObject = null;
                this._editorWrappers = null;
                this._relationEditorsByName = null;
                this._callbacks = null;
                this.displayAttributes = (wvObject) => {
                    this._log.info("WvAttributesComponent.displayAttributes()");
                    this._currentObject = wvObject;
                    this._editorWrappers = [];
                    this._relationEditorsByName = {};
                    if (this._isReady)
                        this._displayData();
                    else
                        this._isWaitingDisplayData = true;
                };
                this.prefillAttributes = (prefillValues) => {
                    this._log.info("WvAttributesComponent.prefillAttributes()");
                    let instance = this;
                    prefillValues.forEach(value => {
                        if (instance._log.isTraceEnabled()) {
                            instance._log.trace("looking at prefill: " + value.Name);
                        }
                        if (value.Relation) {
                            if (instance._log.isTraceEnabled()) {
                                instance._log.trace("using relation value: " + value.Value);
                            }
                            let prefillValue = {
                                Application: value.Relation.ApplicationName,
                                Class: value.Relation.RelatedClassName,
                                ObjectId: +value.Value
                            };
                            instance._setRelation(value.Name, prefillValue);
                        }
                        else {
                            if (instance._log.isTraceEnabled()) {
                                instance._log.trace("using value: " + value.Value);
                            }
                            let editorWrapper = instance._editorWrappers.find(wrapper => wrapper.Editor.AttributeName == value.Name);
                            if (editorWrapper) {
                                editorWrapper.Editor.setValue(value.Value);
                            }
                        }
                    });
                };
                this.switchToEditing = () => {
                    this._log.info("WvAttributesComponent.switchToEditing()");
                    this._editorWrappers.forEach(wrapper => wrapper.switchToEdit());
                };
                this.getChangedValues = () => {
                    this._log.info("WvAttributesComponent.getChangedValues()");
                    if (this._form.reportValidity()) {
                        let result = [];
                        this._editorWrappers.forEach(wrapper => {
                            let value = wrapper.Editor.getChangedValue();
                            if (value !== null) {
                                let existingValue = result.find(val => val.Name == wrapper.Editor.AttributeName);
                                if (existingValue) {
                                    // if we have already a value for this attribute check it has the same value and warn if not
                                    if (existingValue.Value != value.Value) {
                                        console.warn("Different values for attribute '" + wrapper.Editor.AttributeName + "': " + existingValue.Value + " != " + value.Value);
                                    }
                                }
                                else {
                                    result.push(value);
                                }
                            }
                        });
                        return result;
                    }
                    return null;
                };
                this.clearView = () => {
                    this._log.info("WvAttributesComponent.clearView()");
                    if (!this._isReady)
                        return;
                    this._currentObject = null;
                    this._editorWrappers = null;
                    this._relationEditorsByName = null;
                    if (this._formList) {
                        this._formList.innerHTML = "";
                    }
                };
                this._present = () => {
                    this._log.info("WvAttributesComponent._present()");
                    this._container.innerHTML = ComponentWvAttributes.Html;
                    this._form = this._container.querySelector('#workviewAttributesForm');
                    this._formList = this._form.querySelector('#workviewAttributesList');
                    this._form.id = performance.now().toString(10);
                    this._isReady = true;
                    if (this._isWaitingDisplayData)
                        this._displayData();
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("WvAttributesComponent._storeHtml()");
                    ComponentWvAttributes.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._displayData = () => {
                    this._log.info("WvAttributesComponent._displayData()");
                    this._formList.innerHTML = "";
                    let fragment = document.createDocumentFragment();
                    if (this._currentObject) {
                        this._addAttributes(fragment, this._currentObject);
                    }
                    this._formList.appendChild(fragment);
                };
                this._addAttributes = (parent, object) => {
                    this._log.info("WvAttributesComponent._addAttributes()");
                    if (object.hasOwnProperty('Values') && object.Values.length > 0) {
                        let editMode = WPTNamespace.MetadataEditors.WorkViewEditMode.READONLY;
                        if (!object.Class.Readonly) {
                            editMode = WPTNamespace.MetadataEditors.WorkViewEditMode.ARCHIVE;
                        }
                        let valuesLength = object.Values.length;
                        for (let v = 0; v < valuesLength; v++) {
                            let attribute = object.Values[v];
                            let id = this._form.id + "-" + (v + 1);
                            let wrapper = WPTNamespace.MetadataEditors.AttributeEditorFactory.createAttributeWrapper(this._core, this._form, parent, id, attribute, this._callbacks, editMode);
                            this._editorWrappers.push(wrapper);
                            if (wrapper.Editor instanceof WPTNamespace.MetadataEditors.RelationAttributeEditor) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("adding relation editor for attribute: " + attribute.Name);
                                }
                                let namedEditors = this._relationEditorsByName[attribute.Name];
                                if (namedEditors === null || namedEditors === undefined) {
                                    namedEditors = {};
                                    this._relationEditorsByName[attribute.Name] = namedEditors;
                                }
                                let dottedName = attribute.Name;
                                if (attribute.Relation && attribute.Relation.RequestedName) {
                                    dottedName = attribute.Relation.RequestedName;
                                }
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("adding relation editor for dotted name: " + dottedName);
                                }
                                namedEditors[dottedName] = wrapper.Editor;
                            }
                        }
                    }
                    else {
                        console.warn("WvAttributesComponent._addAttributes: NO DATA");
                    }
                };
                this._setRelation = (relationName, requestObject) => {
                    this._log.info("WvAttributesComponent._setRelation()");
                    let requestedAttributes = [];
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking for editors of attribute: " + relationName);
                    }
                    let namedEditors = this._relationEditorsByName[relationName];
                    for (let dottedName in namedEditors) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking for dotted name: " + dottedName);
                        }
                        let firstDot = dottedName.indexOf('.');
                        if (this._log.isTraceEnabled) {
                            this._log.trace("first dot: " + firstDot);
                        }
                        if (firstDot > 0) {
                            if (this._log.isTraceEnabled) {
                                this._log.trace("requesting attribute: " + dottedName.substring(firstDot + 1));
                            }
                            requestedAttributes.push(dottedName.substring(firstDot + 1));
                        }
                    }
                    if (requestedAttributes.length > 0) {
                        requestObject.RequestedAttributes = requestedAttributes;
                    }
                    let request = JSON.stringify(requestObject);
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetObject', request, this._setRelationValue.bind(this, namedEditors), null, this._callErrorHandler, this._callFailedHandler);
                };
                this._setRelationValue = (relationEditors, objectData) => {
                    this._log.info("WvAttributesComponent._setRelationValue()");
                    let objectId = objectData.Object.Id.toString(10);
                    for (let dottedName in relationEditors) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking for dotted name: " + dottedName);
                        }
                        let editor = relationEditors[dottedName];
                        let displayName = objectData.Object.Name;
                        let displayDatatype = "Alphanumeric";
                        if (objectData.Object.Values.length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking for dotted name: " + dottedName);
                            }
                            let searchName = null;
                            let firstDot = dottedName.indexOf('.');
                            if (this._log.isTraceEnabled) {
                                this._log.trace("first dot: " + firstDot);
                            }
                            if (firstDot > 0) {
                                if (this._log.isTraceEnabled) {
                                    this._log.trace("using search name: " + dottedName.substring(firstDot + 1));
                                }
                                searchName = dottedName.substring(firstDot + 1);
                            }
                            let attr = objectData.Object.Values.find(attr => (attr.Name === searchName) || (attr.Relation && attr.Relation.RequestedName === searchName));
                            if (attr) {
                                displayName = attr.Value;
                                displayDatatype = attr.DataType;
                            }
                        }
                        if (this._log.isTraceEnabled) {
                            this._log.trace("using display value '" + displayName + "' of type: " + displayDatatype);
                        }
                        editor.setRelation(objectId, displayName, displayDatatype);
                    }
                };
                this._clearRelation = (relationName) => {
                    this._log.info("WvAttributesComponent._clearRelation()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking for editors of attribute: " + relationName);
                    }
                    let namedEditors = this._relationEditorsByName[relationName];
                    for (let dottedName in namedEditors) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking for dotted name: " + dottedName);
                        }
                        let editor = namedEditors[dottedName];
                        let displayDatatype = "Alphanumeric";
                        let attr = this._currentObject.Values.find(attr => (attr.Name === dottedName) || (attr.Relation && attr.Relation.RequestedName === dottedName));
                        if (attr) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("setting display datatype: " + attr.DataType);
                            }
                            displayDatatype = attr.DataType;
                        }
                        editor.setRelation("0", "", displayDatatype);
                    }
                };
                this._callFailedHandler = (json) => {
                    this._log.info("WvAttributesComponent._callFailedHandler()");
                    let response = json;
                    this._parent.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("WvAttributesComponent._callErrorHandler()");
                    this._parent.addError(message);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("WvAttributesComponent::constructor");
                this._callbacks = callbacks;
                if (!this._callbacks.RelationSetCallback) {
                    this._callbacks.RelationSetCallback = this._setRelation;
                }
                if (!this._callbacks.RelationClearedCallback) {
                    this._callbacks.RelationClearedCallback = this._clearRelation;
                }
                this._isReady = false;
                this._isWaitingDisplayData = false;
                if (!ComponentWvAttributes.Html) {
                    core.Loader.getVersionedHTML('widgets/components/wvAttributes.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
        }
        ComponentWvAttributes.Html = null;
        Widgets.ComponentWvAttributes = ComponentWvAttributes;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
